// @ts-check
import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BusComponent from "../../../BusComponent";
import ChangeVisualization from "./ChangeVisualization";
import ChangeVisualizationCOT from "./ChangeVisualizationCOT";
import ChangeVisualizationSimple from "./ChangeVisualizationSimple";
import Tooltip from "../../../Tooltip";
import BaseMap from "../../../../enums/BaseMapTypes";
import OpacitySlider from './OpacitySlider';


class AutoAdjustMenu extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showChangePalettePopup: false,
        };

        this.menuRef = null;
        this.setMenuRef = element => {
            this.menuRef = element;
        };
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.menuRef && !this.menuRef.contains(event.target)){
            this.setState({ showChangePalettePopup: false });
        }
    }

    toggleMoreOptionsPopup = () => {
        const { forcePalettePopupClose } = this.props;
        const { showChangePalettePopup } = this.state;

        if (showChangePalettePopup) {
            forcePalettePopupClose();
        }
        this.setState(prevState => ({
            showChangePalettePopup: !prevState.showChangePalettePopup
        }));
    };

    render() {
        const { intl, mapInstance, togglePalettePopup, showPercentageControl } = this.props;
        const { showChangePalettePopup } = this.state;

        const ariaLabel = showChangePalettePopup ?
            intl.formatMessage({ id: 'showHide.hide.autoAdjustMenu' }) :
            intl.formatMessage({ id: 'showHide.show.autoAdjustMenu' });

        let changeVisualization;
        if (mapInstance.dataTheme.isChangeOverTimeApplied) {
            changeVisualization = (
                <ChangeVisualizationCOT
                    mapInstanceId={mapInstance.id}
                    dataTheme={mapInstance.dataTheme}
                />
            );
        } else {
            changeVisualization = showPercentageControl ?
                <ChangeVisualization
                    mapInstanceId={mapInstance.id}
                    dataTheme={mapInstance.dataTheme}
                /> :
                <ChangeVisualizationSimple
                    mapInstanceId={mapInstance.id}
                    dataTheme={mapInstance.dataTheme}
                />;
        }

        const showOpacitySlider = mapInstance.isSatelliteVisible;

        return (
            <div className="flex-it auto-adjust__menu" ref={this.setMenuRef}>
                <Tooltip
                    placement="right"
                    mouseEnterDelay={0.5}
                    mouseLeaveDelay={0}
                    overlay={intl.formatMessage({
                        id: 'dataBrowser.moreVisualizationOptions',
                    })}
                >
                    <button
                        className={classNames("btn-icon btn-icon--small", {
                            'opened-btn': showChangePalettePopup
                        })}
                        onClick={this.toggleMoreOptionsPopup}
                        aria-label={ariaLabel}
                    >
                        <i className="material-icons" aria-hidden> more_horiz </i>
                    </button>
                </Tooltip>
                {showChangePalettePopup && (
                    <div className="auto-adjust__popover auto-adjust__menu__popover">
                        {changeVisualization}
                        <div className="actions">
                            <button onClick={togglePalettePopup}>
                                {intl.formatMessage({ id: 'legend.changeColorPalette' })}
                                <i className="material-icons"> arrow_right </i>
                            </button>
                        </div>
                        {showOpacitySlider && <OpacitySlider mapInstance={mapInstance} />}
                    </div>
                )}
            </div>
        );
    }
}

AutoAdjustMenu.propTypes = {
    intl: PropTypes.object.isRequired,
    mapInstance: PropTypes.object.isRequired,
    showPercentageControl: PropTypes.bool.isRequired,
    togglePalettePopup: PropTypes.func.isRequired,
    forcePalettePopupClose: PropTypes.func.isRequired,
};

export default injectIntl(AutoAdjustMenu);
